<template>
  <div class="flex-column">
    <sticky :className="'sub-navbar'">
      <div class="filter-container">
        <el-input
          @keyup.enter.native="handleFilter"
          size="mini"
          style="width: 180px;"
          class="filter-item"
          placeholder="账号 / UID / 会话 / 轮次"
          v-model="listQuery.key"
        ></el-input>
        <el-select v-model="listQuery.mode" size="mini" class="filter-item" style="width: 110px;">
          <el-option label="全部模式" :value="0"></el-option>
          <el-option label="聊天" :value="1"></el-option>
          <el-option label="翻译" :value="2"></el-option>
        </el-select>
        <el-select v-model="listQuery.status" size="mini" class="filter-item" style="width: 120px;">
          <el-option label="全部状态" :value="0"></el-option>
          <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <el-date-picker
          v-model="timeRange"
          size="mini"
          class="filter-item"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          style="width: 360px;"
        ></el-date-picker>
        <el-button class="filter-item" size="mini" v-waves icon="el-icon-search" @click="handleFilter">搜索</el-button>
      </div>
    </sticky>

    <div class="app-container flex-item">
      <div class="bg-white" style="height: 100%; padding: 10px;">
        <el-table :data="list" v-loading="listLoading" border size="mini" style="width: 100%;">
          <el-table-column prop="createdAt" label="时间" width="150"></el-table-column>
          <el-table-column prop="account" label="账号" width="120"></el-table-column>
          <el-table-column prop="uid" label="UID" width="100"></el-table-column>
          <el-table-column label="模式" width="70" align="center">
            <template slot-scope="scope">
              <el-tag size="mini" :type="scope.row.mode === 2 ? 'warning' : ''">
                {{ scope.row.mode === 2 ? '翻译' : '聊天' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="profileCode" label="配置" width="130"></el-table-column>
          <el-table-column prop="voice" label="音色" width="130"></el-table-column>
          <el-table-column prop="targetLanguage" label="目标语言" width="100">
            <template slot-scope="scope">
              {{ scope.row.targetLanguage || '-' }}
            </template>
          </el-table-column>
          <el-table-column label="首包" width="80" align="right">
            <template slot-scope="scope">
              {{ scope.row.firstChunkMs == null ? '-' : scope.row.firstChunkMs + 'ms' }}
            </template>
          </el-table-column>
          <el-table-column label="耗时" width="80" align="right">
            <template slot-scope="scope">
              {{ scope.row.elapsedMs == null ? '-' : scope.row.elapsedMs + 'ms' }}
            </template>
          </el-table-column>
          <el-table-column prop="inputTokens" label="输入Token" width="90" align="right"></el-table-column>
          <el-table-column prop="outputTokens" label="输出Token" width="90" align="right"></el-table-column>
          <el-table-column label="状态" width="90" align="center">
            <template slot-scope="scope">
              <el-tag size="mini" :type="statusType(scope.row.status)">{{ statusLabel(scope.row.status) }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="70" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="openDetail(scope.row)">详情</el-button>
            </template>
          </el-table-column>
        </el-table>

        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.limit"
          @pagination="handleCurrentChange"
        />
      </div>

      <el-dialog title="会话记录详情" :visible.sync="detailVisible" width="720px">
        <table class="detail-table" v-if="detail">
          <tbody>
            <tr>
              <th>时间</th>
              <td>{{ detail.createdAt }}</td>
              <th>账号 / UID</th>
              <td>{{ detail.account }} / {{ detail.uid }}</td>
            </tr>
            <tr>
              <th>终端会话</th>
              <td>{{ detail.sessionId || '-' }}</td>
              <th>轮次标识</th>
              <td>{{ detail.turnId || '-' }}</td>
            </tr>
            <tr>
              <th>模式</th>
              <td>{{ detail.mode === 2 ? '翻译' : '聊天' }}</td>
              <th>配置</th>
              <td>{{ detail.profileCode || '-' }}</td>
            </tr>
            <tr>
              <th>音色</th>
              <td>{{ detail.voice || '-' }}</td>
              <th>目标语言</th>
              <td>{{ detail.targetLanguage || '-' }}</td>
            </tr>
            <tr>
              <th>上行音频</th>
              <td>{{ detail.inputAudioMs || 0 }} ms</td>
              <th>下行音频</th>
              <td>{{ detail.outputAudioMs || 0 }} ms</td>
            </tr>
            <tr>
              <th>首包延迟</th>
              <td>{{ detail.firstChunkMs == null ? '-' : detail.firstChunkMs + ' ms' }}</td>
              <th>总耗时</th>
              <td>{{ detail.elapsedMs == null ? '-' : detail.elapsedMs + ' ms' }}</td>
            </tr>
            <tr>
              <th>输入 / 输出 Token</th>
              <td>{{ detail.inputTokens || 0 }} / {{ detail.outputTokens || 0 }}</td>
              <th>状态</th>
              <td>
                <el-tag size="mini" :type="statusType(detail.status)">{{ statusLabel(detail.status) }}</el-tag>
              </td>
            </tr>
            <tr>
              <th>配置兜底</th>
              <td colspan="3">{{ detail.configFallback || '-' }}</td>
            </tr>
            <tr>
              <th>错误信息</th>
              <td colspan="3">{{ detail.errorMessage || '-' }}</td>
            </tr>
            <tr>
              <th>AI 播报转写</th>
              <td colspan="3"><div class="detail-text">{{ detail.aiText || '-' }}</div></td>
            </tr>
          </tbody>
        </table>
        <div slot="footer">
          <el-button size="mini" @click="detailVisible = false">关闭</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import * as records from '@/api/realtimeChatRecords'
import waves from '@/directive/waves'
import Sticky from '@/components/Sticky'
import Pagination from '@/components/Pagination'

const STATUS_MAP = {
  1: { label: '成功', type: 'success' },
  2: { label: '被抢占', type: 'warning' },
  3: { label: '上游异常', type: 'danger' },
  4: { label: '超时', type: 'warning' },
  5: { label: '空输入', type: 'info' },
}

export default {
  name: 'realtimeChatRecord',
  components: { Sticky, Pagination },
  directives: { waves },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: false,
      timeRange: null,
      detailVisible: false,
      detail: null,
      statusOptions: Object.keys(STATUS_MAP).map((key) => ({ value: Number(key), label: STATUS_MAP[key].label })),
      listQuery: {
        page: 1,
        limit: 20,
        key: undefined,
        mode: 0,
        status: 0,
      },
    }
  },
  created() {
    this.getList()
  },
  methods: {
    statusLabel(status) {
      const item = STATUS_MAP[status]
      return item ? item.label : `未知(${status})`
    },
    statusType(status) {
      const item = STATUS_MAP[status]
      return item ? item.type : 'info'
    },
    getList() {
      this.listLoading = true
      const params = Object.assign({}, this.listQuery)
      if (this.timeRange && this.timeRange.length === 2) {
        params.beginTime = this.timeRange[0]
        params.endTime = this.timeRange[1]
      }
      records
        .getList(params)
        .then((response) => {
          this.list = response.data || []
          this.total = response.count || 0
        })
        .catch(() => {
          this.list = []
          this.total = 0
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val.page
      this.listQuery.limit = val.limit
      this.getList()
    },
    openDetail(row) {
      this.detail = row
      this.detailVisible = true
    },
  },
}
</script>

<style scoped>
.detail-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  table-layout: fixed;
}
.detail-table th,
.detail-table td {
  border: 1px solid #EBEEF5;
  padding: 6px 10px;
  text-align: left;
  vertical-align: top;
  word-break: break-all;
}
.detail-table th {
  width: 110px;
  background: #FAFAFA;
  color: #606266;
  font-weight: normal;
}
.detail-text {
  white-space: pre-wrap;
  word-break: break-all;
  max-height: 200px;
  overflow: auto;
  line-height: 1.6;
}
</style>
